import {
  fetchSsrHtml,
  fetchSsrStyles,
  waitForElement,
} from "../../core/common/ssr-utils.js";
import {
  buildForwardedQueryParams,
  COURSESU_CATALOG_ROUTES,
  getCatalogSsrEndpoints
} from "./catalog-routing.js";
import { getPosExtId } from "./utils.js";
import { getSsrBaseUrl } from "./coursesu-env.js";


const RECIPE_CATALOG_PLACEHOLDER = "webc-miam-recipe-catalog";
const MAX_RECIPES_PER_CATEGORY = 6;
const DISPLAY_RECIPE_VARIANT = 2;
const PLANNER_ENTRY_VARIANT = 1; // Variant 1 is current selection only

export async function injectCatalog(headers) {
  const target = await waitForElement(RECIPE_CATALOG_PLACEHOLDER, {
    maxAttempts: 20,
    intervalMs: 250,
  });
  if (!target) {
    console.warn(`[CoursesU] ${RECIPE_CATALOG_PLACEHOLDER} not found`);
    return;
  }

  try {
    const { htmlEndpoint, stylesEndpoint } = getCatalogSsrEndpoints();
    const isMySpace = htmlEndpoint === COURSESU_CATALOG_ROUTES.mySpace.htmlEndpoint;

    // SSR v3 defaults planner_entry styles to variant 3 (scoped `.variant-N`); keep in sync with HTML.
    fetchSsrStyles(
      `${stylesEndpoint}?recipe_card_variant=${DISPLAY_RECIPE_VARIANT}&planner_entry_variant=${PLANNER_ENTRY_VARIANT}`,
      getSsrBaseUrl()
    );

    const html = await fetchSsrHtml(
      htmlEndpoint,
      headers,
      {
        max_recipes_per_category: MAX_RECIPES_PER_CATEGORY,
        recipe_card_variant: DISPLAY_RECIPE_VARIANT,
        planner_entry_variant: PLANNER_ENTRY_VARIANT,
        store_id: getPosExtId(),
        ...buildForwardedQueryParams(),
        ...(isMySpace ? { history_style: "grid" } : {}),
      },
      getSsrBaseUrl()
    );

    target.insertAdjacentHTML("afterend", html);
    target.remove();
  } catch (err) {
    console.error("[CoursesU] catalog SSR injection failed", err);
  }
}

export function listenHeaderHeightChange() {
  const headerElement = document.querySelector('[data-header]');
  if (!headerElement) {
    return;
  }

  const observer = new MutationObserver(() => {

    const bottom = headerElement.getBoundingClientRect().bottom;
    if (bottom >= 0) {
      globalThis.mealz.setStickyHeaderHeight(bottom);
    }
    // if bottom < 0 it means U's header is in an animation, so we need to wait for the animation to finish
    else {
      globalThis.mealz.setStickyHeaderHeight(0);
      waitForStickyHeaderAnimation()
    }
  });

  observer.observe(
    headerElement.parentElement,
    { attributes: true, childList: true, subtree: true }
  );
}

/**
 * Wait 50 * 15 = 700ms for the header animation to finish
 */
function waitForStickyHeaderAnimation(timesLeft = 50) {
  const headerElement = document.querySelector('[data-header]');
  if (timesLeft > 0 && headerElement) {
    setTimeout(() => {
      const bottom = headerElement.getBoundingClientRect().bottom;
      globalThis.mealz.setStickyHeaderHeight(Math.max(bottom, 0));
      waitForStickyHeaderAnimation(timesLeft - 1);
    }, 15)
  }
}
